import { IsBoolean, IsEnum, IsNotEmpty, IsOptional, Length, MinLength } from 'class-validator';

import { PublicProfileTypeEnum } from '@onArte/shared/database';
import { ListQuery } from '@onArte/shared/models/common';

export class PublicProfileListQuery extends ListQuery {
  @IsNotEmpty()
  @IsEnum(PublicProfileTypeEnum)
  public type: PublicProfileTypeEnum;

  @IsOptional()
  @MinLength(1)
  public phrase?: string;

  @IsOptional()
  @IsBoolean()
  public highlighted?: boolean;

  @IsOptional()
  @IsBoolean()
  public sortByHighlighted?: boolean;

  @IsOptional()
  @Length(32, 36, { each: true })
  public contextIds?: string[];

  constructor(
    limit: number | undefined,
    offset: number | undefined,
    type: PublicProfileTypeEnum,
    phrase?: string,
    highlighted?: boolean,
    sortByHighlighted?: boolean,
    contextIds?: string[]
  ) {
    super(limit, offset);

    this.type = type;
    this.phrase = phrase;
    this.highlighted = highlighted;
    this.sortByHighlighted = sortByHighlighted;
    this.contextIds = contextIds;
  }
}
